import React, {useEffect, useRef, useState} from 'react';
import plateIcon from "../../assets/img/plate.png";
import motorPlate from "../../assets/img/motor.png";
import CONST from "../../const";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import {toast} from "react-toastify";


const Injured = (props) => {

    const {company} = props

    const [plate, setPlate] = useState({})

    const [form , setForm] = useState({
        chassis_number_injered: props.detail && props.detail.chassis_number_injered,
        motor_number_injered: props.detail && props.detail.motor_number_injered,
        name_injered: props.detail && props.detail.name_injered,
        certificate_injered: props.detail && props.detail.certificate_injered,
        base_number_injered: props.detail && props.detail.base_number_injered,
        issue_date_injered: props.detail && props.detail.issue_date_injered || moment(),
        restrictions_injered: props.detail.restrictions_injered || -1,
        national_code_injered: props.detail && props.detail.national_code_injered,
        insurance_number_injered: props.detail && props.detail.insurance_number_injered,
        startDate_injered:props.detail && props.detail.startDate_injered || moment(),
        expiration_date_injered: props.detail && props.detail.expiration_date_injered  || moment(),
        company_injered: props.detail && props.detail.company_injered,
        financial_injered: null,
        commitment_injered: null,
        owner_car_injered: props.detail && props.detail.owner_car_injered,
        unique_code_injered: props.detail && props.detail.unique_code_injered ? props.detail && props.detail.unique_code_injered : props.detail && props.detail.injured_insurance_unique_code && props.detail.injured_insurance_unique_code,
        mobile_number_injered: props.detail && props.detail.mobile_number_injered !== null && props.detail.mobile_number_injered,
        phone_injered: props.detail && props.detail.phone_injered,
        disciplinary_injered: props.detail && props.detail.disciplinary_injered,
        automatic_injered: props.detail && props.detail.automatic_injered,
        address_injered: props.detail && props.detail.address_injered,
        car_type_injered: props.detail.car_type_injered ? props.detail.car_type_injered : 1,
        car_system_injered: props.detail && props.detail.car_system_injered,
        license_number_injered: props.detail && props.detail.license_number_injered,
        id: props.detail && props.detail.id ? props.detail && props.detail.id : null,
        shaba: props.detail && props.detail.shaba,
        company_injered_body: props.detail && props.detail.company_injered_body,
        insurance_number_injered_body: props.detail && props.detail.insurance_number_injered_body,
        damage_branch: props.detail && props.detail.damage_branch,
        bank_name: props.detail && props.detail.bank_name,
        color_injered: props.detail && props.detail.color_injered,
        model_injered: props.detail && props.detail.model_injered,
        issued_injered: props.detail && props.detail.issued_injered,
        owner_national_code_injered: props.detail && props.detail.owner_national_code_injered,
        father_name_injered: props.detail && props.detail.father_name_injered,
        birthday_injered: props.detail && props.detail.birthday_injered || moment(),
        expiration_date_injered_body:props.detail && props.detail.expiration_date_injered_body || moment(),
        start_date_injered_body: props.detail && props.detail.start_date_injered_body  || moment(),
        damaged_points_injered: props.detail && props.detail.damaged_points_injered,
        plate_injered: "",
    })




    const [restrictionsInjeredOption, setRestrictionsInjeredOption] = useState(+form?.restrictions_injered === 0 ? 0 : +form?.restrictions_injered === -1 ? -1 : 1)
    const [extra, setExtra] = useState(!(+props.detail?.restrictions_injered === 0 || +props.detail?.restrictions_injered === -1))

    const refExtra = useRef()

    useEffect(() => {
        props.getData({...form})
    } ,[])



    useEffect(() => {
        getPlate()
    }, [props.detail])



    useEffect(() => {
        let list = CONST.INJURED_LIST

        if(+form.car_type_injered === 5) {
            list = CONST.INJURED_LIST_OTHER
        }
        if(+props.type=== 1 && +form.car_type_injered !== 5) {
            list = CONST.INJURED_LIST_SALES
        }

        for(let i = 0 ; i < list?.length ; i++ ) {
            let names = list[i]
            let emptyElement = document.querySelector("[name=" + names + "]")
            if(emptyElement !== null && emptyElement.previousSibling !== null) {
                emptyElement.previousSibling.classList.add("mandatory")
            }
        }
    }, [form.car_type_injered])

    const getPlate = () => {
        let plate = props.detail && props.detail.plate_injered && props.detail.plate_injered.split("-")
        let alphabet = plate && plate.filter((item) => {
            return isNaN(item) && item !== "null"
        })
        let number = plate && plate.filter((item) => {
            return !isNaN(item) && item !== "null"
        })
        let obj = {
            leftInjered: props.detail ? number && number[1] : "",
            rightInjered: props.detail ? number && number[2] : "",
            topInjered: props.detail ? number && number[0] : "",
            left2Injered: props.detail ? number && number[0] : "",
            centerInjered: props.detail && alphabet && alphabet[0] ? alphabet && alphabet[0] : "الف",
            downInjered: props.detail ? number && number[1] : "",
        }
        setPlate(obj)

        let defaultPlate = +props.detail.car_type_injered !== 2 ? `${(obj.left2Injered) && (obj.left2Injered).trim()}-${(obj.leftInjered) && (obj.leftInjered).trim()}-${(obj.centerInjered) && (obj.centerInjered).trim()}-${(obj.rightInjered) && (obj.rightInjered).trim()}` : `${(obj.topInjered) && (obj.topInjered).trim()}-${(obj.downInjered) && (obj.downInjered).trim()}`

        setForm({...form , "plate_injered":defaultPlate})
    }

    const handleChangeElement = (event) => {
        let frm = {...plate};
        frm[event.target.name] = event.target.value;
        setPlate(frm);
        if(frm.leftInjered !== "" && frm.rightInjered !== "" && frm.left2Injered !== "" && +form.car_type_injered !== 2) {
            handleSetData({name:"plate_injered" , value: `${(frm.left2Injered) && (frm.left2Injered).trim()}-${(frm.leftInjered) && (frm.leftInjered).trim()}-${(frm.centerInjered) && (frm.centerInjered).trim()}-${(frm.rightInjered) && (frm.rightInjered).trim()}`})
        }
        if(frm.downInjered !== "" && frm.topInjered !== "" && +form.car_type_injered === 2) {
            handleSetData({name:"plate_injered" , value: `${(frm.topInjered) && (frm.topInjered).trim()}-${(frm.downInjered) && (frm.downInjered).trim()}`})
        }
    };

    const handleFocusElement = (event) => {
        let frm = {...plate};
        frm[event.target.name] = "";
        setPlate(frm);
    };


    const handleRestrictions = (event) => {
        if(+event === 1) {
            console.log(event)

            handleSetData({name:"restrictions_injered" , value:null})
        } else {
            handleSetData({name:"restrictions_injered" , value:+event})
        }

    }


    const handleSetData = (e) => {
        let obj = {...form , [e.name]:e.value}
        setForm((prevState => ({...prevState , [e.name]:e.value})))
        console.log(form)
        props.getData(obj)
    }

    const alphabet = CONST.ALPHABET
    const carTypeList = CONST.CAR_TYPE


    return (
        <div onKeyDown={() => {
            props.alarm(true)
        }} onBlur={(e) => handleSetData(e)} className="insurance-table">

            {
                !props.editCondition && <div  onClick={() => toast.error("جهت ایجاد تغییرات بر روی دکمه ویراش کلیک نمایید")} className={"disable-cover"}/>
            }
            <div className="table-head">
                {`مشخصات زیان دیده ${form.name_injered?.length > 0 ? " / " + form.name_injered : ""}`}
            </div>
            <div className="table-body">
                <div className="table-body-item">
                    <span>
                        نوع خودرو :
                    </span>
                    <select name={"car_type_injered"} value={form.car_type_injered} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                        props.alarm(true)
                    }} className="table-body-item-select">
                        {
                            carTypeList && carTypeList.map((item) => {
                                return (
                                    <option value={item.id}>{item.title}</option>
                                )
                            })
                        }
                    </select>
                </div>

                <div className="table-body-item">
                    تیپ و سیستم خودرو :
                    <input name={"car_system_injered"} value={form.car_system_injered} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                    }} className="table-body-item-input"/>
                </div>
                {
                    +form.car_type_injered !== 5 &&
                    <>
                        <div style={{justifyContent: "right"}} className="table-body-item">
                            اتوماتیک :
                            <input value={form.automatic_injered} name={"automatic_injered"} defaultChecked={form.automatic_injered === "1"}
                                   onChange={(e) => {
                                       handleSetData({name:e.target.name , value:e.target.checked ? 1 : 2})
                                   }} type={"checkBox"} className="table-body-item-checkBox"/>
                        </div>
                        <div className="table-body-item" style={{justifyContent: "unset"}}>
                                  <span>
                                   شماره انتظامی :
                                   </span>
                            {
                                +form.car_type_injered !== 2 ?
                                    <>
                                        <img name={"plate_injered"}  className="table-body-item-img" src={plateIcon}/>
                                        <input onFocus={(e) => {
                                            handleFocusElement(e)
                                        }} value={plate.rightInjered} onChange={(e) => {
                                            handleChangeElement(e)
                                        }} name={"rightInjered"} maxLength={2}
                                               className="table-body-item-right-number"/>
                                        <div className="table-body-item-left-number">
                                            <input onFocus={(e) => {
                                                handleFocusElement(e)
                                            }} value={plate.leftInjered} onChange={(e) => {
                                                handleChangeElement(e)
                                            }} name={"leftInjered"} maxLength={3}/>
                                            <select onFocus={(e) => {
                                                handleFocusElement(e)
                                            }} value={plate.centerInjered} onChange={(e) => {
                                                props.alarm(true)
                                                handleChangeElement(e)
                                            }} name={"centerInjered"}>
                                                <option
                                                    value={-1}>{plate.centerInjered ? plate.centerInjered : `انتخاب`}</option>
                                                {
                                                    alphabet && alphabet.map((item) => {
                                                        return (
                                                            <option value={item.title}>{item.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <input onFocus={(e) => {
                                                handleFocusElement(e)
                                            }} value={plate.left2Injered} onChange={(e) => {
                                                handleChangeElement(e)
                                            }} name={"left2Injered"} maxLength={2}/>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <img name={"plate_injered"}  className="table-body-item-img-motor" src={motorPlate}/>
                                        <div className="table-body-item-motor-number">
                                            <input onFocus={(e) => {
                                                handleFocusElement(e)
                                            }} value={plate.topInjered} onChange={(e) => {
                                                handleChangeElement(e)
                                            }} name={"topInjered"} maxLength={3}/>
                                            <input onFocus={(e) => {
                                                handleFocusElement(e)
                                            }} value={plate.downInjered} onChange={(e) => {
                                                handleChangeElement(e)
                                            }} name={"downInjered"} maxLength={5}/>
                                        </div>
                                    </>
                            }

                        </div>
                        <div className="table-body-item">
                            <div>
                                رنگ :
                            </div>
                            <select name={"color_injered"} value={form.color_injered} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                                props.alarm(true)
                            }} className="table-body-item-select">
                                <option value={"-1"}>{"انتخاب کنید"}</option>
                                {
                                    CONST.COLOR && CONST.COLOR.map((item) => {
                                        return (
                                            <option value={item.id}>{item.title}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className="table-body-item">
                            مدل :
                            <input name={"model_injered"} type={"number"} value={form.model_injered} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                            }} className="table-body-item-input"/>
                        </div>
                        <div className="table-body-item">
                                  <span>
                                     شماره شاسی :
                                   </span>
                            <input name={"chassis_number_injered"} value={form.chassis_number_injered} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                            }} className="table-body-item-input"/>

                        </div>

                        <div className="table-body-item">
                              <span>
                                شماره موتور :
                              </span>
                            <input name={"motor_number_injered"} value={form.motor_number_injered} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                            }} className="table-body-item-input"/>

                        </div>
                        <div className="table-body-item">
                                <span>
                                 نام راننده :
                              </span>
                            <input name={"name_injered"} value={form.name_injered} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value});
                            }}
                              className="table-body-item-input"/>

                        </div>
                        <div className="table-body-item">
                             <span>
                            کد ملی راننده:
                              </span>
                            <input name={"national_code_injered"} type={"number"} value={form.national_code_injered} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                            }} className="table-body-item-input"/>
                        </div>

                        <div className="table-body-item">
                            نام پدر:
                            <input name={"father_name_injered"} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                            }}   value={form.father_name_injered} className="table-body-item-input"/>

                        </div>

                        <div className="table-body-item">
                            شماره شناسنامه :
                            <input name={"certificate_injered"} type={"number"} value={form.certificate_injered} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                            }} className="table-body-item-input"/>

                        </div>
                        <div className="table-body-item">
                             <span>
                            شماره گواهینامه :
                              </span>
                            <input name={"license_number_injered"} type={"number"} value={form.license_number_injered} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                            }} className="table-body-item-input"/>

                        </div>
                        <div className="table-body-item">
                             <span>
                            شماره پایه گواهینامه :
                              </span>
                            <select name={"base_number_injered"} value={form.base_number_injered} className={"table-body-item-select"}
                                    onChange={(e) => {
                                        handleSetData({name:e.target.name , value:e.target.value})
                                        props.alarm(true)
                                    }}>
                                <option value={"-1"}>{"انتخاب کنید"}</option>

                                {CONST.BASE_NUMBER && CONST.BASE_NUMBER.map((item) => {
                                    return (
                                        <option value={item.id}>{item.title}</option>
                                    );
                                })}
                            </select>
                        </div>

                        <div className='datepicker-input-container'>
                            <div className={"table-body-item"}>
                                 <span>
                                    تاریخ صدور :
                              </span>
                                <DatePicker
                                    name={"issue_date_injered"}
                                    isGregorian={false}
                                    timePicker={false}
                                    onChange={issueDateInjered => {
                                        handleSetData({name:"issue_date_injered" , value:moment(issueDateInjered).format('jYYYY/jM/jD')})
                                    }}
                                />
                            </div>
                        </div>

                        <div ref = {refExtra} className="table-body-item">
                            <span>
                                محدودیت رانندگی :
                            </span>
                            <select name={"restrictions_injered"}
                                    onChange={(e) => {
                                        handleSetData({name:e.target.name , value:e.target.value})
                                        setExtra(+e.target.value === 1)
                                        setRestrictionsInjeredOption(+e.target.value)
                                        handleRestrictions(+e.target.value)

                                    }}
                                    className="table-body-item-select">
                                <option value={"-1"}>{"انتخاب کنید"}</option>

                                {
                                    CONST.YES_OR_NO?.map((item) => {
                                        return (
                                            <option selected={item.id === restrictionsInjeredOption } value={item.id}>{item.name}</option>
                                        )
                                    })
                                }
                            </select>

                        </div>

                        {
                            extra &&
                            <div className="table-body-item">
                             <span>
                            توضیحات محدودیت :
                              </span>

                                <input name={"restrictions_injered"} value={form.restrictions_injered} onChange={(e) => {
                                    handleSetData({name:e.target.name , value:e.target.value})
                                }} className="table-body-item-input"/>

                            </div>
                        }

                        <div className="table-body-item">
                             <span>
                            شماره بیمه نامه ثالث:
                              </span>
                            <input name={"insurance_number_injered"} value={form.insurance_number_injered} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                            }} className="table-body-item-input"/>

                        </div>
                        <div className="table-body-item">
                             <span>
                            کد یکتا ثالث:
                              </span>
                            <input name={"unique_code_injered"} type={"number"} value={form.unique_code_injered}
                                   onChange={(e) => {
                                       handleSetData({name:e.target.name , value:e.target.value});
                                   }}
                                   className="table-body-item-input"/>

                        </div>
                        <div className='datepicker-input-container'>
                            <div className={"table-body-item"}>
                                 <span>
                                    تاریخ شروع ثالث:
                              </span>

                                <DatePicker
                                    name={"startDate_injered"}
                                    isGregorian={false}
                                    timePicker={false}
                                    onChange={startDateInjered => {
                                        handleSetData({name:'startDate_injered' , value:moment(startDateInjered).format('jYYYY/jM/jD')})
                                    }}
                                />
                            </div>
                        </div>
                        <div className='datepicker-input-container'>
                            <div className={"table-body-item"}>
                                 <span>
                                    تاریخ انقضا ثالث:
                              </span>

                                <DatePicker
                                    name={"expiration_date_injered"}
                                    isGregorian={false}
                                    timePicker={false}
                                    onChange={expirationDateInjered => {
                                        handleSetData({name:"expiration_date_injered" , value:moment(expirationDateInjered).format('jYYYY/jM/jD')})
                                    }}
                                />
                            </div>
                        </div>

                        <div className="table-body-item">
                             <span>
                            شرکت بیمه ثالث:
                              </span>
                            <select name={"company_injered"} value={form.company_injered} className={"table-body-item-select"} onChange={(e) => {
                                handleSetData({name:e.target.name , value:e.target.value})
                                props.alarm(true)
                            }}>
                                <option value={"-1"}>{"انتخاب کنید"}</option>
                                {company && company.map((item) => {
                                    return (
                                        <option value={item && item.id && item.id}>{item && item.title}</option>
                                    );
                                })}
                            </select>
                        </div>
                        {
                            props.type == "2" &&
                            <>
                                <div className="table-body-item">
                                     <span>
                                    شماره بیمه نامه بدنه:
                                     </span>
                                    <input name={"insurance_number_injered_body"} value={form.insurance_number_injered_body} onChange={(e) => {
                                        handleSetData({name:e.target.name , value:e.target.value})
                                    }} className="table-body-item-input"/>

                                </div>

                                <div className='datepicker-input-container'>
                                    <div className={"table-body-item"}>
                                        <div>
                                            تاریخ شروع بدنه:
                                        </div>

                                        <DatePicker
                                            name={"start_date_injered_body"}
                                            isGregorian={false}
                                            timePicker={false}
                                            onChange={startDateInjeredBody => {
                                                handleSetData({name:"start_date_injered_body" , value:moment(startDateInjeredBody).format('jYYYY/jM/jD')})
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='datepicker-input-container'>
                                    <div className={"table-body-item"}>
                                        <div>
                                            تاریخ انقضا بدنه:
                                        </div>

                                        <DatePicker
                                            isGregorian={false}
                                            timePicker={false}
                                            onChange={expirationDateInjeredBody => {
                                                handleSetData({name:"expiration_date_injered_body" , value:moment(expirationDateInjeredBody).format('jYYYY/jM/jD')})
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="table-body-item">
                                      <span>
                                     شرکت بیمه بدنه:
                                     </span>
                                    <select name={"company_injered_body"} value={form.company_injered_body} className={"table-body-item-select"}
                                            onChange={(e) => {
                                                handleSetData({name:e.target.name , value:e.target.value})
                                                props.alarm(true)
                                            }}>
                                        <option value={"-1"}>{"انتخاب کنید"}</option>

                                        {company && company.map((item) => {
                                            return (
                                                <option value={item.id}>{item.title}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </>
                        }
                    </>
                }

                <div className="table-body-item">
                     <span>
                    نام مالک خودرو :
                     </span>
                    <input name={"owner_car_injered"} value={form.owner_car_injered} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                    }} className="table-body-item-input"/>

                </div>

                <div className="table-body-item">
                     <span>
                    کد ملی مالک :
                     </span>
                    <input name={"owner_national_code_injered"} type={"number"} value={form.owner_national_code_injered} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                    }} className="table-body-item-input"/>

                </div>
                <div className='datepicker-input-container'>
                    <div className={"table-body-item"}>
                        <div>
                            تاریخ تولد مالک:
                        </div>

                        <DatePicker
                            isGregorian={false}
                            timePicker={false}
                            onChange={birthdayInjered => {
                                handleSetData({name:"birthday_injered" , value:moment(birthdayInjered).format('jYYYY/jM/jD')});
                            }}
                        />
                    </div>
                </div>
                <div className="table-body-item">
                    صادره از :
                    <input name={"issued_injered"} value={form.issued_injered}
                           onChange={(e) => {
                               handleSetData({name:e.target.name , value:e.target.value});
                           }}
                           className="table-body-item-input"/>

                </div>
                <div className="table-body-item">
                     <span>
                    تلفن همراه :
                      </span>
                    <input name={"mobile_number_injered"} type={"number"} value={form.mobile_number_injered}
                           onChange={(e) => {
                               handleSetData({name:e.target.name , value:e.target.value});
                           }}
                           className="table-body-item-input"/>

                </div>
                <div className="table-body-item">
                    تلفن ثابت :
                    <input name={"phone_injered"} type={"number"} value={form.phone_injered} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                    }} className="table-body-item-input"/>

                </div>

                <div style={{width: '100%', justifyContent: "right"}} className="table-body-item">
                    آدرس :
                    <input name={"address_injered"} value={form.address_injered} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                    }} className="table-body-item-input"/>
                </div>
                <div style={{width: '100%', justifyContent: "right"}} className="table-body-item">
                    نقاط آسیب دیده :
                    <input name={"damaged_points_injered"} value={form.damaged_points_injered} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                    }} className="table-body-item-input"/>
                </div>

                <div style={{width: "45%"}} className="table-body-item">
                     <span>
                    شماره حساب/شبا :
                     </span>
                    <input name={"shaba"} value={form.shaba} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                    }} style={{width: "70%"}} type={"number"} className="table-body-item-input"/>

                </div>

                <div className="table-body-item">
                    نام بانک :
                    <input name={"bank_name"} value={form.bank_name} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                    }} className="table-body-item-input"/>

                </div>

                <div className="table-body-item">
                    شعبه دریافت خسارت :
                    <input name={"damage_branch"} value={form.damage_branch} onChange={(e) => {
                        handleSetData({name:e.target.name , value:e.target.value})
                    }} className="table-body-item-input"/>

                </div>
            </div>

        </div>
    );
};

export default Injured;